import React from 'react';
import {
  useGetCustomerReportingQuery,
  useGetReportingQuery,
} from '../../redux/api/marktApi';

const MarktDashboard = () => {
  const { data: reportData } = useGetReportingQuery();
  const { data: reportData2 } = useGetCustomerReportingQuery();

  return (
    <div>
      <p>Welcome to the new shiny Getränkemarkt interface!</p>
    </div>
  );
};

export default MarktDashboard;
